import { Row } from "antd";
import { FunctionalComponent, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useLocation } from "react-router-dom";
import { PrimaryButton } from "../../components/button/primary";
import { SecondaryButton } from "../../components/button/secondary";
import Container from "../../components/container";
import { InputLabel } from "../../components/form/input/input";
import WrapperComponent from "../../components/hoc/WrapperComponent";
import { TextHeader } from "../../components/text";
import { convertDateTimeThailand } from "../../functions";
import { useMessage } from "../../hooks/useMessage";
import { COULMN_DATA } from "./constants/columns";
import { SEARCH_FORM, DEVICEID_FORM } from "./constants/search";
import { useQc } from "./hook/useQc";
import { useSearchData } from "./hook/useSearchData";
import { ContainerButton, ContainerTable } from "./style/styled";
import { TableData } from "./view/table/data";

const QCDeviceScene: FunctionalComponent = () => {
  const [timer, setTimer] = useState(null as NodeJS.Timeout | null);
  const { openMessage } = useMessage();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const pl = params.get("p");
  const [loading, setLoading] = useState(false);
  const [forceLoading, setForceLoading] = useState(true);
  const [forceLoadingSearch, setForceLoadingSearch] = useState(false);
  const { onSearch, data, onClearForm, setData } = useSearchData();
  const [statePL, setStatePL] = useState(pl as string);
  const [deviceId, setDeviceId] = useState("");
  const { onConfirm } = useQc();

  const onFetchSearch = async () => {
    pl && (await onSearch(pl));
    setForceLoading(false);
  };

  useEffect(() => {
    onFetchSearch();
  }, [pl]);

  const onChangeText = (e: any, item: any) => {
    const { ref } = item;
    switch (ref) {
      case "search_pl":
        setStatePL(`${e.target.value}`.toUpperCase());
        break;
      case "deviceid":
        setDeviceId(`${e.target.value}`.toUpperCase());
        break;
      default:
        break;
    }
  };

  const onPress = async (i?: string | null, force?: boolean) => {
    setDeviceId("");
    force && setForceLoadingSearch(true);
    setLoading(true);
    window.history.replaceState(null, "", `?p=${i || statePL}`);
    await onSearch(statePL);
    force && setForceLoadingSearch(false);
    setLoading(false);
  };

  const onPressClearText = async (i?: string | null, force?: boolean) => {
    setStatePL("");
    force && setForceLoading(true);
    setLoading(true);
    window.history.replaceState(null, "", `?p=${i || statePL}`);
    onClearForm();
    force && setForceLoading(false);
    setLoading(false);
  };

  const onPressQC = async (text?: string | null) => {
    const i = text || deviceId;
    try {
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
      const t = setTimeout(async () => {
        const findIndex = data.findIndex((e) => e.deviceID === i);
        if (findIndex === -1) {
          return openMessage("error", `ไม่พบเลข ${i} ในระบบ`);
        }
        const { deviceID } = data[findIndex];
        const r = await onConfirm(deviceID);
        if (!r) {
          return;
        }
        openMessage("success", `${deviceID} ตรวจสอบสำเร็จ`);
        const d = JSON.parse(JSON.stringify(data));
        d[findIndex].statusName = "WAITING-INVOICE";
        d[findIndex].seq = 1;
        d[findIndex].qcDate = convertDateTimeThailand(new Date());
        const newD = d.filter((e: any) => e.deviceID !== d[findIndex].deviceID);
        const newData = [d[findIndex], ...newD].map(
          (e: any, index: number) => ({
            ...e,
            index: index + 1,
          })
        );
        setData(newData);
        setDeviceId("");
      }, 500);
      setTimer(t);
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.message);
    }
  };

  return (
    <Container>
      <TextHeader text={"QC เครื่องตัด"} divider={true} />
      <Row>
        {
          (
            <InputLabel
              item={SEARCH_FORM}
              handleChange={onChangeText}
              onEnter={onPress}
              value={statePL}
            />
          ) as React.ReactNode
        }
        {
          (
            <ContainerButton>
              <PrimaryButton
                label={"ค้นหา"}
                style={{ marginTop: "20px", marginLeft: "10px" }}
                mobileStyle={{ marginTop: "10px" }}
                tabletStyle={{ marginTop: "10px" }}
                onPress={onPress}
                isLoading={true}
                forceLoading={forceLoadingSearch}
              />
              <SecondaryButton
                label={"ล้างข้อมูล"}
                style={{ marginTop: "20px", marginLeft: "10px" }}
                mobileStyle={{ marginTop: "10px" }}
                tabletStyle={{ marginTop: "10px" }}
                onPress={onPressClearText}
                isLoading={true}
                forceLoading={forceLoading}
              />
            </ContainerButton>
          ) as React.ReactNode
        }
        {
          (
            <InputLabel
              item={DEVICEID_FORM}
              handleChange={onChangeText}
              onEnter={onPressQC}
              value={deviceId}
            />
          ) as React.ReactNode
        }
        {
          (
            <PrimaryButton
              label={"ยืนยัน"}
              style={{ marginTop: "20px", marginLeft: "10px" }}
              mobileStyle={{ marginTop: "10px" }}
              tabletStyle={{ marginTop: "10px" }}
              onPress={onPressQC}
              isLoading={true}
              forceLoading={forceLoading}
            />
          ) as React.ReactNode
        }
      </Row>
      <ContainerTable>
        <TableData columns={COULMN_DATA()} data={data} loading={loading} />
      </ContainerTable>
    </Container>
  );
};

export default WrapperComponent("QCDeviceScene")(QCDeviceScene);
